import { render } from "./SuggestionsKB.vue?vue&type=template&id=5b79ae68&scoped=true"
import script from "./SuggestionsKB.vue?vue&type=script&lang=js"
export * from "./SuggestionsKB.vue?vue&type=script&lang=js"

import "./SuggestionsKB.vue?vue&type=style&index=0&id=5b79ae68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b79ae68"]])

export default __exports__